import { useEffect, useMemo, useState } from 'react'

import { Box, makeStyles } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { Link, useLocation } from 'react-router-dom'

import { COBRAND_ALIAS, SOURCES } from 'common/coalition-sources'
import { useLogin } from 'common/login-service'
import SignInForm from 'components/SignIn'
import { SignInFormValues } from 'components/SignIn/SignInForm.types'
import Title from 'components/Title'

import OAuthForm from '../OAuthForm'

const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.palette.primary.dark,
    textDecoration: 'underline',
    margin: theme.spacing(2, 0),
  },
}))

const useQuery = () => {
  const { search } = useLocation()
  return useMemo(() => {
    const params = new URLSearchParams(search)
    return {
      scid: parseInt(params.get('scid') || '', 10),
      source: params.get('source') as 'C' | 'CM',
    }
  }, [search])
}

export const SignInRoute = () => {
  const classes = useStyles()
  const { source, scid } = useQuery()
  const [submit, setSubmit] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [params, setParams] = useState('')

  useEffect(() => {
    const params: { [k: string]: any } = {}
    if (scid) {
      params.scid = scid
    }
    if (source) {
      params.source = COBRAND_ALIAS[source]
      if (!SOURCES.includes(COBRAND_ALIAS[source])) {
        setParams('')
      } else {
        setParams(`?${new URLSearchParams(params).toString()}`)
      }
    }
  }, [source, scid])

  const login = useLogin()

  const handleCredentialsSubmit = async (values: SignInFormValues) => {
    await login(values.email, values.password, params)
  }

  return (
    <>
      <OAuthForm submit={submit} />
      {error && (
        <Box mb={2}>
          <Alert severity="error">{error}</Alert>
        </Box>
      )}
      <Title title="Log in 👋" />
      <SignInForm
        onSubmit={handleCredentialsSubmit}
        onSuccess={() => setSubmit(true)}
        onError={setError}
      />
      <Link
        to="/forgot-password"
        className={classes.link}
      >
        Forgot password?
      </Link>
    </>
  )
}

export default SignInRoute
